import type { Func } from '@ricoh/ria.client.core/types/core/function.type';

import { Url } from '@ricoh/ria.client.core/utils/es/url';

import type { ServiceServerIdentityConfig, ServiceServerIdentityModule } from './_config.type';

import serviceServerConfigBase from '../_config';

/**
 * Create ServiceServer Identity request config.
 *
 * @template TEndpoints Endpoints config.
 * @param {ServiceServerIdentityModule} moduleName Request module name.
 * @param {Func<[keyBase: string], TEndpoints>} createEndpoints Endpoints config creator.
 *
 * @returns {ServiceServerIdentityConfig<TEndpoints>} ServiceServer Identity request config.
 */
export default function createRequestConfig<TEndpoints extends Record<string, unknown>>(
  moduleName: ServiceServerIdentityModule,
  createEndpoints: Func<[keyBase: string], TEndpoints>,
): ServiceServerIdentityConfig<TEndpoints> {
  const module = `identity.${moduleName}` as const;

  const keyBase = new Url()
    .resolve(import.meta.env.APP_SERVER_BASE_WEB)
    .resolve(import.meta.env.APP_SERVER_PATH_IDENTITY)
    .toString();

  return {
    module,
    options: serviceServerConfigBase.options(keyBase),
    endpoints: createEndpoints(keyBase),
    createError: serviceServerConfigBase.createError(module),
  };
}
